/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable consistent-return */

import { useMemo } from 'react'
import { formatPaceTimes } from '../../Utils'

const usePaceOverviewCards = ( fgJob ) => {
  const ss = useMemo( () => {
    const stages = Object.values( fgJob?.suctionSideJob?.data?.stage ?? {} )
    const lastStage = stages.filter( s => !!s?.startTime && !s?.endTime )[0]
    const validStages = stages.filter( s => !!s?.startTime && !!s?.endTime )

    const targetPace =
      validStages.reduce(
        ( acc, stage ) => acc + ( stage?.targetDuration ?? 0 ),
        0,
      ) / 3600

    const completed =
      ( !lastStage || !!lastStage?.endTime ) && validStages.length !== 0

    const currentPace =
      validStages.reduce(
        ( acc, stage ) => acc + ( stage?.actualDuration ?? 0 ),
        0,
      ) /
        3600

    const status = validStages.length ?
      currentPace > targetPace ?
        'Bad' :
        'Good' :
      'Idle'

    return {
      status,
      completed,
      title : 'SS Shell (Completed Stages)',
      currentPace : formatPaceTimes( currentPace ),
      targetPace : formatPaceTimes( targetPace ),
      stage : lastStage?.ctGroupDescription ?? '-',
    }
  }, [ fgJob ] )

  const ps = useMemo( () => {
    const stages = Object.values( fgJob?.pressureSideJob?.data?.stage ?? {} )
    const validStages = stages.filter( s => !!s?.startTime && !!s?.endTime )
    const lastStage = stages.filter( s => !!s?.startTime && !s?.endTime )[0]

    const targetPace =
      validStages.reduce(
        ( acc, stage ) => acc + ( stage?.targetDuration ?? 0 ),
        0,
      ) / 3600

    const completed =
      ( !lastStage || !!lastStage?.endTime ) && validStages.length !== 0

    const currentPace =
      validStages.reduce(
        ( acc, stage ) => acc + ( stage?.actualDuration ?? 0 ),
        0,
      ) /
        3600

    const status = validStages.length ?
      currentPace > targetPace ?
        'Bad' :
        'Good' :
      'Idle'

    return {
      status,
      completed,
      title : 'PS Shell (Completed Stages)',
      currentPace : formatPaceTimes( currentPace ),
      targetPace : formatPaceTimes( targetPace ),
      stage : lastStage?.ctGroupDescription ?? '-',
    }
  }, [ fgJob ] )

  const bnd = useMemo( () => {
    const stages = Object.values( fgJob?.bondedBladeJob?.data?.stage ?? {} )
    const validStages = stages.filter( s => !!s?.startTime && !!s?.endTime )
    const lastStage = stages.filter( s => !!s?.startTime && !s?.endTime )[0]

    const targetPace =
      validStages.reduce(
        ( acc, stage ) => acc + ( stage?.targetDuration ?? 0 ),
        0,
      ) / 3600

    const completed =
      ( !lastStage || !!lastStage?.endTime ) && validStages.length !== 0

    const currentPace =
      validStages.reduce(
        ( acc, stage ) => acc + ( stage?.actualDuration ?? 0 ),
        0,
      ) /
        3600

    const status = validStages.length ?
      currentPace > targetPace ?
        'Bad' :
        'Good' :
      'Idle'

    return {
      status,
      completed,
      title : 'BND (Completed Stages)',
      currentPace : status === 'Idle' ? '-' : formatPaceTimes( currentPace ),
      targetPace : status === 'Idle' ? '-' : formatPaceTimes( targetPace ),
      stage : lastStage?.ctGroupDescription ?? '-',
    }
  }, [ fgJob ] )

  const overall = useMemo( () => {
    const bndStages = fgJob?.bondedBladeJob?.data?.stage ?? {}
    const ssStages = fgJob?.suctionSideJob?.data?.stage ?? {}

    const validStages = stages => Object.values( stages ).filter( s => !!s?.startTime && !!s?.endTime )

    const getSum = stages => validStages( stages ).reduce(
      ( acc, stage ) => acc + ( stage?.actualDuration ?? 0 ),
      0,
    ) / 3600
    const getTarget = stages => validStages( stages ).reduce(
      ( acc, stage ) => acc + ( stage?.targetDuration ?? 0 ),
      0,
    ) / 3600

    const targetPace = getTarget( bndStages ) + getTarget( ssStages )

    const currentPace =
      getSum( bndStages ) +
      getSum( ssStages )

    const status =
      validStages( ssStages ).length || validStages( bndStages ).length ?
        currentPace > targetPace ?
          'Bad' :
          'Good' :
        'Idle'

    return {
      status,
      title : 'Overall Blade (SS + BND)',
      currentPace : formatPaceTimes( currentPace ),
      targetPace : formatPaceTimes( targetPace ),
    }
  }, [ fgJob ] )

  return {
    paces : { ss, ps, bnd, overall },
  }
}

export default usePaceOverviewCards
